import(/* webpackMode: "eager" */ "/vercel/path0/src/design-system/Icons.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/GitHub/YearlyContribution.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/design-system/border-gradient.module.css")